const DescriptiveSummary = function(min, max, median, mean, stdDev, count) {
    this.min = min;
    this.max = max;
    this.median = median;
    this.mean = mean;
    this.standardDev = stdDev;
    this.count = count;
}

const RhinoCard = function(preOp, threeMonthPostOp, twelveMonthPostOp) {
    this.preOp = preOp;
    this.threeMonthPostOp = threeMonthPostOp;
    this.twelveMonthPostOp = twelveMonthPostOp;
}

const RhinoRow = function(descSummary, median, months) {
    this.descriptiveSummary = descSummary;
    this.median = median;
    this.months = months;
};

const createEmptyRhinoCard = function() {
    let summaryPreOp = new DescriptiveSummary("-", "-", "-", "-", "-", "-");
    let summaryThreeMonthPostOp = new DescriptiveSummary("-", "-", "-", "-", "-", "-");
    let summaryTwelveMonthPostOp = new DescriptiveSummary("-", "-", "-", "-", "-", "-");
    
    let rhinoRowPreOp = new RhinoRow(summaryPreOp, "-", "-");
    let rhinoRowThreeMonthPostOp = new RhinoRow(summaryThreeMonthPostOp, "-", "-");
    let rhinoRowTwelveMonthPostOp = new RhinoRow(summaryTwelveMonthPostOp, "-", "-");

    return new RhinoCard(rhinoRowPreOp, rhinoRowThreeMonthPostOp, rhinoRowTwelveMonthPostOp);
}

export { createEmptyRhinoCard };